import { axiosPrivate } from "./AxiosPrivate";


export const getNotifications = (page, limit) => axiosPrivate.get(`/notification/get-notifications?page=${page}&limit=${limit}`,)

export const markNotificationAsRead = (notificationId) => axiosPrivate.put(`/notification/read/${notificationId}`,)

export const markAllNotificationsAsRead = () => axiosPrivate.put(`/notification/read-all/`,)

export const deleteNotificationforUser = (notificationId) => axiosPrivate.put(`/notification/delete/${notificationId}`,)


// FCM
export const saveFCMToken = (token) => axiosPrivate.post('/notification/saveFCMToken',token)